const isOnline = location => {
    const { address, city } = location;
    if (address && (address.toLowerCase() === 'online' || address.toLowerCase() === 'virtual')) {
        return true;
    }
    if (city && (city.toLowerCase() === 'online' || city.toLowerCase() === 'virtual')) {
        return true;
    }
    return false;
};

export const transformLocation = location => {
    if (!location) {
        return null;
    }

    if (isOnline(location)) {
        return 'Virtual';
    }

    let { city, state, country } = location;

    if (country === 'United States') {
        country = 'USA';
    }

    // Richmond, Virginia, USA
    if (city && state && country) {
        return `${city}, ${state}, ${country}`;
    }

    // Richmond, Virginia
    if (city && state && !country) {
        return `${city}, ${state}`;
    }

    // Richmond, USA
    if (city && !state && country) {
        return `${city}, ${country}`;
    }

    // Richmond
    if (city) {
        return city;
    }

    // Virginia
    if (state) {
        return state;
    }

    // USA
    if (country) {
        return country;
    }

    return null;
};
